import validate from "validate.js";

window._ = require('lodash');

window.Popper = require('popper.js').default;

window.$ = window.jQuery = require('jquery');

window.toastr = require('toastr');

window.moment = require('moment');

window.Tether = require("tether");

window.Dropzone = require("dropzone");
window.Dropzone.autoDiscover = false;

window.approve = require("approvejs");


// See https://validatejs.org/#examples for available constraints
$.fn.validateForm = function (constraints, cb) {
    const $form = $(this);

    let fields = {};
    let keyFields = {};

    const $fields = $form.find($('input, select'));

    for (let i = 0; i < $fields.length; i++) {
        let field = $($fields[i]);

        fields[field.attr('name')] = {
            $: field,
            value: field.val()
        };

        keyFields[field.attr('name')] = field.val();
    }

    const validation = validate(keyFields, constraints);
    const invalid = typeof validation !== 'undefined';

    cb(invalid, validation, $form);

    return $(this);
};

$.fn.validateFormListen = function (constraints, cb) {
    $(this).off('change').on('change', function () {
        $(this).validateForm(constraints, cb);
    });
};